"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlotWrapper = void 0;
const token_utils_1 = require("@saberhq/token-utils");
const spl_token_1 = require("@solana/spl-token");
const bn_js_1 = require("bn.js");
const farmer_1 = require("./farmer");
const payroll_1 = require("./payroll");
class PlotWrapper {
    constructor(saber, program, 
    /**
     * The token being staked.
     */
    token, 
    /**
     * The data of the landlord.
     */
    landlordData, 
    /**
     * The data of the plot.
     */
    plotData, 
    /**
     * The key of the plot.
     */
    key) {
        this.saber = saber;
        this.program = program;
        this.token = token;
        this.landlordData = landlordData;
        this.plotData = plotData;
        this.key = key;
    }
    /**
     * Loads a plot
     * @returns
     */
    static load({ saber, program, token, key, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const plotData = yield program.account.plot.fetch(key);
            const landlordData = yield program.account.landlord.fetch(plotData.landlordKey);
            return new PlotWrapper(saber, program, token, landlordData, plotData, key);
        });
    }
    /**
     * Get the computed rewards rate of the plot
     *
     * You probably don't want this. You want plotData.dailyRewardsRate.
     *
     * @returns dailyRewardsRate
     */
    computeDailyRewardsRate() {
        const landlord = this.landlordData;
        const totalRewardsShares = landlord.totalRewardsShares;
        if (totalRewardsShares.isZero()) {
            return new spl_token_1.u64(0);
        }
        const numerator = landlord.dailyRewardsRate.mul(this.plotData.rewardsShare);
        return numerator.div(totalRewardsShares);
    }
    /**
     * Get the public key of the farmer assocaited with the authority account
     * @param authority who owns the farmer
     * @returns farmer public key
     */
    getFarmerAddress(authority) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.program.account.farmer.associatedAddress(authority, this.key);
        });
    }
    /**
     * Get the farmer data associated with the authority account
     * @param authority
     * @returns
     */
    getFarmer(authority) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.program.account.farmer.associated(authority, this.key);
        });
    }
    /**
     * Get the farmer associated with the authority account
     * @param authority
     * @returns
     */
    getFarmerActions(authority = this.program.provider.wallet.publicKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const farmer = yield this.getFarmerAddress(authority);
            const stakedTokenATA = yield (0, token_utils_1.getATAAddress)({
                mint: this.plotData.tokenMintKey,
                owner: authority,
            });
            const tokenVaultKey = yield (0, token_utils_1.getATAAddress)({
                mint: this.plotData.tokenMintKey,
                owner: farmer,
            });
            return this.createFarmerWrapper(authority, farmer, tokenVaultKey, stakedTokenATA);
        });
    }
    /**
     * Creates a farmer wrapper
     * @param authority
     * @param farmerKey
     * @param tokenVaultKey
     * @param stakedTokenATA
     * @returns
     */
    createFarmerWrapper(authority, farmerKey, tokenVaultKey, stakedTokenATA) {
        return new farmer_1.FarmerWrapper(this, authority, farmerKey, tokenVaultKey, stakedTokenATA);
    }
    /**
     * Creates the farmer of the provided wallet.
     */
    createFarmer({ authority = this.program.provider.wallet.publicKey, } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const farmer = yield this.getFarmerAddress(authority);
            const farmerVault = yield (0, token_utils_1.getATAAddress)({
                mint: this.plotData.tokenMintKey,
                owner: farmer,
            });
            const stakedTokenATA = yield (0, token_utils_1.getATAAddress)({
                mint: this.plotData.tokenMintKey,
                owner: authority,
            });
            const wrapper = this.createFarmerWrapper(authority, farmer, farmerVault, stakedTokenATA);
            return wrapper.initialize();
        });
    }
    /**
     * Payroll helper
     */
    get payroll() {
        const data = this.plotData;
        return new payroll_1.Payroll(data.famineTs, data.lastUpdateTs, data.dailyRewardsRate, data.rewardsPerTokenStored, new bn_js_1.BN(data.tokenMintDecimals), data.totalTokensDeposited);
    }
}
exports.PlotWrapper = PlotWrapper;
//# sourceMappingURL=plot.js.map